function addClassOnVisibility(className, threshold, targetElement, options = {}) {
    if (Object.keys(options).length > 0) {
        if (options.hasOwnProperty('init_class')) {
            options.init_class.forEach(initClass => {
                targetElement.classList.add(initClass);
            });
        }
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Ajouter la classe d'animation
                entry.target.classList.add(className);
                // Ajouter la classe de durée si elle existe
                if (options.hasOwnProperty('duration')) {
                    entry.target.classList.add(options.duration);
                }
            }
        });
    });

    // Observer l'élément avec le sélecteur fourni
    observer.observe(targetElement);
}

window.addEventListener('DOMContentLoaded', () => {
    const correspondance = {
        'left-to-right': ['visibility-hidden'],
        'right-to-left': ['visibility-hidden'],
        'right-to-leftmap': ['visibility-hidden'],
        'fade-in': ['opacity-hidden']
    };
    document.querySelectorAll('[class*="animate-"]').forEach(element => {
        const classListArray = Array.from(element.classList);
        const animateClass = classListArray.find(className => className.includes('animate-'));

        if (animateClass) {
            const match = animateClass.match(/^animate-([\w-]+)-(\d+)$/);

            if (match) {
                const baseClass = `animate-${match[1]}-${match[2]}`; // Classe de base ("animate-left-to-right-2")
                const number = match[2]; // Le chiffre à la fin
                const intermediateClass = match[1]; // Partie intermédiaire ("left-to-right")

                addClassOnVisibility(
                    intermediateClass,
                    0.4,
                    element,
                    {
                        init_class: correspondance[intermediateClass],
                        duration: `${intermediateClass}-${number}`
                    }
                );
            }
        }
    });
});
